import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "attribution", "videoId", "error", "submitButton", "toast"]

  disconnect() {
    clearTimeout(this.closeTimer)
    clearTimeout(this.toastTimer)
    clearTimeout(this.toastRemoveTimer)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    clearTimeout(this.closeTimer)
    this.trigger = event.currentTarget
    this.formTarget.reset()
    this.attributionTarget.value = this.trigger.dataset.feedbackAttribution
    this.videoIdTarget.value = this.trigger.dataset.feedbackVideoId
    this.clearError()
    this.submitButtonTarget.disabled = false

    if (!this.dialogTarget.open) this.dialogTarget.showModal()
    if (this.animatedSheet) void this.dialogTarget.offsetWidth
    this.dialogTarget.classList.add("is-open")
  }

  close() {
    if (!this.dialogTarget.open) return
    if (!this.animatedSheet) { this.dialogTarget.close(); return }

    this.dialogTarget.classList.remove("is-open")
    clearTimeout(this.closeTimer)
    this.closeTimer = setTimeout(() => {
      if (this.dialogTarget.open) this.dialogTarget.close()
    }, 150)
  }

  async submit(event) {
    event.preventDefault()
    this.clearError()
    this.submitButtonTarget.disabled = true

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        body: new FormData(this.formTarget),
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      })
      const body = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(body.error || "We couldn’t save that feedback. Please try again.")

      this.trigger.textContent = "Feedback sent"
      this.trigger.disabled = true
      this.trigger.classList.add("is-submitted")
      this.showToastAfterClose()
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.errorTarget.classList.remove("hidden")
      this.submitButtonTarget.disabled = false
    }
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  onClose() {
    this.dialogTarget.classList.remove("is-open")
    if (!this.toastAfterClose) return

    this.toastAfterClose = false
    this.showToast()
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }

  showToastAfterClose() {
    if (!this.dialogTarget.open) {
      this.showToast()
      return
    }

    this.toastAfterClose = true
    this.close()
  }

  showToast() {
    clearTimeout(this.toastTimer)
    clearTimeout(this.toastRemoveTimer)
    this.toastTarget.hidden = false
    void this.toastTarget.offsetWidth
    this.toastTarget.classList.add("is-visible")
    this.toastTimer = setTimeout(() => this.hideToast(), 4000)
  }

  hideToast() {
    this.toastTarget.classList.remove("is-visible")
    this.toastRemoveTimer = setTimeout(() => {
      this.toastTarget.hidden = true
    }, 180)
  }

  get animatedSheet() {
    return window.matchMedia("(max-width: 640px)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
